export const RULE_MANAGEMENTS = 'RuleManagements'
export const RULE_MANAGEMENT_DETAILS = 'RuleManagementDetails'

export const GIFT_CONDITIONS = 'GiftConditions'
export const GIFT_CONDITION_DETAILS = 'GiftConditionDetails'

export const PRODUCTS = 'Products'

export const CUSTOMER_DETAILS = 'CustomerDetails'
export const CUSTOMER_REPORT = 'CustomerReport'
export const CUSTOMER_REPORT_ALL = 'CustomerReportAll'

export const TEM_ACCUMULATIONS = 'TemAccumulations'

export const GIFT_TRANSACTION_HISTORY = 'GiftTransactionHistory'
